import { render } from "./ScrollTopComponent.vue?vue&type=template&id=7b60cd7e&scoped=true"
import script from "./ScrollTopComponent.vue?vue&type=script&lang=js"
export * from "./ScrollTopComponent.vue?vue&type=script&lang=js"

import "./ScrollTopComponent.vue?vue&type=style&index=0&id=7b60cd7e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b60cd7e"]])

export default __exports__